import type {GridSettings} from './types';

const DEFAULT_SETTINGS: GridSettings<any> = {
    colorAccented: false,
    columnPinningEnabled: false,
    columnResizingEnabled: false,
    condensed: false,
    editable: false,
    hoverColumns: false,
    hoverRows: false,
    mainGroupsDivided: false,
    selectionEnabled: false,
    stickyHeader: false,
    showOnlyTopAndBottomHeaders: false,
    rowClassTemplate: () => ''
}

export function createGridSettings<ROW>(customSettings: Partial<GridSettings<ROW>>): GridSettings<ROW> {
    return {...DEFAULT_SETTINGS, ...customSettings};
}